import { useEffect, useRef } from "react";

/**
 * ============================================================================
 *  useClavierSurcouche.ts — Le clavier appartient à la surcouche tant qu'elle est ouverte
 * ----------------------------------------------------------------------------
 *  Le menu, la feuille et les crédits sont modaux : Espace (lecture du guide), ← →
 *  (rotation de la vue), Échap (reprise du guide)… ne doivent pas agir derrière eux.
 *  Plutôt que de modifier chaque raccourci de la visite, l'écoute se pose en CAPTURE sur
 *  `document` et arrête la propagation : rien n'arrive plus aux écouteurs de `window`.
 *
 *  Seule `Tab` passe (le piège de focus, `usePiegeFocus`, la traite). L'action par défaut
 *  n'est jamais annulée ici : Entrée et Espace continuent d'activer le bouton focalisé.
 * ==========================================================================*/

export function useClavierSurcouche(actif: boolean, surTouche: (event: KeyboardEvent) => void): void {
  const courant = useRef(surTouche);
  courant.current = surTouche;

  useEffect(() => {
    if (!actif) return;
    const ecoute = (event: KeyboardEvent) => {
      if (event.key === "Tab") return;
      event.stopPropagation();
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      courant.current(event);
    };
    document.addEventListener("keydown", ecoute, true);
    return () => document.removeEventListener("keydown", ecoute, true);
  }, [actif]);
}
